<ng-container *ngIf="role && role !== 'MODERATOR'">
  <h1>UNAUTHORISED ACCESS</h1> <br>
  <h3>Please Login as CUSTOMER, redirecting ...</h3>
  {{unauthorised()}}
</ng-container>
<ng-container *ngIf="role && role === 'MODERATOR'">
  <div class="wrapper">
    <br>
    <div class="content">
      <!-- CUSTOMERS -->
      <ng-container *ngIf="customers">
        <div class="alert alert-danger" role="alert" *ngIf="customers.length === 0">
          No Customers to Edit/Delete
        </div>
        <div class="alert alert-primary" role="alert" *ngIf="customers.length !== 0">
          Available customers to Edit/Delete
        </div>
        <div class="card">
          <div class="card-body">
            <table class="table table-hover">
              <thead class=" text-primary">
                <tr>
                  <th>User ID</th>
                  <th>User Name</th>
                  <th>Full Name</th>
                  <th>Email ID</th>
                  <th>Contact Number</th>
                  <th>Edit</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let customer of customers">
                  <td>{{customer._id}}</td>
                  <td>{{customer.userName}}</td>
                  <td>{{customer.fullName}}</td>
                  <td>{{customer.email}}</td>
                  <td>{{customer.contactNumber}}</td>
                  <td>
                    <button class="btn btn-lg btn-outline-primary" (click)="openCustomer(customerModal, customer._id)"><mat-icon>edit</mat-icon> {{customer.fullName}}</button>
                  </td>
                  <td>
                    <button class="btn btn-lg btn-outline-primary" (click)="deleteCustomer(customer._id)"><mat-icon>delete</mat-icon> {{customer.fullName}}</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>
      <!-- TECH EXPERTS -->
      <ng-container *ngIf="experts">
        <div class="alert alert-danger" role="alert" *ngIf="experts.length === 0">
          No Experts to Edit/Delete
        </div>
        <div class="alert alert-primary" role="alert" *ngIf="experts.length !== 0">
          Available Experts to Edit/Delete
        </div>
        <table class="table table-hover">
          <thead class=" text-primary">
            <tr>
              <th scope="col">Expert ID</th>
              <th scope="col">User Name</th>
              <th scope="col">Full Name</th>
              <th scope="col">Email ID</th>
              <th scope="col">Contact Number</th>
              <th scope="col">Edit</th>
              <th scope="col">Delete</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let expert of experts">
              <td>{{ expert._id }}</td>
              <td>{{ expert.userName }}</td>
              <td>{{ expert.fullName }}</td>
              <td id="email">{{ expert.email }}</td>
              <td>{{ expert.contactNumber }}</td>
              <td>
                <button class="btn btn-lg btn-outline-primary" (click)="openExpert(expertModal, expert._id)"><mat-icon>edit</mat-icon> {{expert.fullName}}</button>
              </td>
              <td>
                <button class="btn btn-lg btn-outline-primary" (click)="deleteExpert(expert._id)"><mat-icon>delete</mat-icon> {{expert.fullName}}</button>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>
  </div>
  <ng-template #customerModal let-modal>
    <div class="modal-header">
      <div class="modal-title" id="modal-basic-title">Edit Customer</div>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">×</span>
      </button>
    </div>


    <form (submit)="editCustomer()" [formGroup]="customerForm">
      <div class="modal-body">



        <div id="left" class="cred">Company Email:</div><input id="right" type="text" formControlName="email"><br>
        <mat-error id="right" *ngIf="customerForm.controls['email'].invalid"> email error </mat-error>
        <br>
        
        <div id="left" class="cred"> Contact Person Email:</div><input id="right" type="text" formControlName="pEmail"><br>
        <mat-error id="right" *ngIf="customerForm.controls['pEmail'].invalid"> contact email error </mat-error>
        <br>
        
        <div id="left" class="cred"> Company Contact Number:</div><input id="right" type="text" formControlName="contactNumber"><br>
        <mat-error id="right" *ngIf="customerForm.controls['contactNumber'].invalid"> Contact Number length must be 10 characters </mat-error>
        <br>
        
        <div id="left" class="cred"> Contact Person Number:</div><input id="right" type="text" formControlName="pContactNumber"><br>
        <mat-error id="right" *ngIf="customerForm.controls['pContactNumber'].invalid"> Contact Number length must be 10 characters </mat-error>
        <br>

        <div id="left" class="cred">GST Number</div><input id="right" type="text" formControlName="gstNumber"><br>
        <mat-error *ngIf="customerForm.controls['gstNumber'].invalid && customerForm.controls['gstNumber'].errors.required"> GST Number Required </mat-error>
        <mat-error *ngIf="customerForm.controls['gstNumber'].invalid && (customerForm.controls['gstNumber'].errors.minlength || customerForm.controls['gstNumber'].errors.maxlength)"> Length should be 15 </mat-error>
        <br>

        <div id="left" class="cred">PAN</div><input id="right" type="text" formControlName="PAN"><br>
        <mat-error *ngIf="customerForm.controls['PAN'].invalid && customerForm.controls['PAN'].errors.required"> PAN Required </mat-error>
        <mat-error *ngIf="customerForm.controls['PAN'].invalid && (customerForm.controls['PAN'].errors.minlength || customerForm.controls['PAN'].errors.maxlength)"> Length should be 10 </mat-error>
        <br>

        <div id="left" class="cred">Currency</div><input id="right" type="text" formControlName="currency"><br>
        <mat-error *ngIf="customerForm.controls['currency'].invalid && customerForm.controls['currency'].errors.required"> Currency Required </mat-error>
        <br>
        
        <div id="left" class="cred">Bank Name</div><input id="right" type="text" formControlName="bankName"><br>
        <mat-error *ngIf="customerForm.controls['bankName'].invalid && customerForm.controls['bankName'].errors.required"> Bank Name Required </mat-error>
        <br>

        <div id="left" class="cred">Bank Account Number</div><input id="right" type="text" formControlName="bankAccountNumber"><br>
        <mat-error *ngIf="customerForm.controls['bankAccountNumber'].invalid && customerForm.controls['bankAccountNumber'].errors.required"> Bank Account Required </mat-error>
        <br>

        <div id="left" class="cred">IFSC</div><input id="right" type="text" formControlName="IFSC"><br>
        <mat-error *ngIf="customerForm.controls['IFSC'].invalid && customerForm.controls['IFSC'].errors.required"> IFSC Required </mat-error>
        <mat-error *ngIf="customerForm.controls['IFSC'].invalid && (customerForm.controls['IFSC'].errors.minlength || customerForm.controls['IFSC'].errors.maxlength)"> Length should be 11 </mat-error>
        <br>

        <div id="left" class="cred">SWIFT</div><input id="right" type="text" formControlName="SWIFT"><br>
        <mat-error *ngIf="customerForm.controls['SWIFT'].invalid && customerForm.controls['SWIFT'].errors.required"> SWIFT Required </mat-error>
        <mat-error *ngIf="customerForm.controls['SWIFT'].invalid && (customerForm.controls['SWIFT'].errors.minlength || customerForm.controls['SWIFT'].errors.maxlength)"> Length should be 11 </mat-error>
        <br>
      </div>
      <br>

      <div class="modal-footer">
        <button type="submit" class="btn btn-outline-dark" [disabled]="customerForm.invalid" (click)="modal.close('Save click')">Submit Changes</button>
      </div>
    </form>
  </ng-template>


  <ng-template #expertModal let-modal>
    <div class="modal-header">
      <div class="modal-title" id="modal-basic-title">Edit Expert</div>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <form (submit)="editExpert()" [formGroup]="expertForm">
      <div class="modal-body">
        <div id="left" class="cred">Expert Email:</div><input id="right" type="text" formControlName="email"><br>
        <mat-error id="right" *ngIf="customerForm.controls['email'].invalid"> email error </mat-error>
        <br>
        <div id="left" class="cred"> Expert Contact Numer:</div><input id="right" type="text" formControlName="contactNumber"><br>
        <mat-error id="right" *ngIf="customerForm.controls['contactNumber'].invalid"> Contact Number length must be 10 characters </mat-error>
        <br>
        <br>
      </div>
      <br>
      <div class="modal-footer">
        <button type="submit" class="btn btn-outline-dark" [disabled]="expertForm.controls['email'].invalid" (click)="modal.close('Save click')">Edit</button>
      </div>
    </form>
  </ng-template>
</ng-container>
